import React, { useCallback } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import TierCard from 'Pods/Profile/Settings/SubscriptionManagement/Shared/TierCard/TierCard'
import I18n from 'Pods/Shared/I18n'
import { PLAN_MONTHLY } from 'Pods/SubscriptionCheckout/Constants/plans'

import formatPrice from 'Utils/formatPrice'

import { TIER } from '../../constants'
import { availablePlansShape, catalogValuesShape } from '../../propTypes'

const TRANSLATION_KEY_PREFIX = 'subscription_management.empty_state.plans_restructure'
const FEATURES_KEY_PREFIX = 'subscription_checkout.plans_restructure.plan_card.features'
const FEATURE_SLOTS = ['first', 'second']

function NoSubscription({
  availablePlans, catalogValues = null, paymentFormUrl, showPremiumPlans = false, locale = 'en',
}) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(`${TRANSLATION_KEY_PREFIX}.${key}`, { ns: 'rails', lng: locale, ...options }),
    [locale],
  )
  const essentialsDownloads = availablePlans[TIER.ESSENTIALS].downloadsPerMonth
  const tiers = showPremiumPlans && availablePlans.premiumCheckoutAvailable
    ? [TIER.ESSENTIALS, TIER.PREMIUM]
    : [TIER.ESSENTIALS]

  return (
    <section className="no-subscription" aria-labelledby="no-subscription-title">
      <h3 id="no-subscription-title" className="cgt-heading-300">{translate('title')}</h3>
      <p className="cgt-body-md no-subscription__intro">{translate('intro', { downloads: essentialsDownloads })}</p>
      <div className="no-subscription__tiers">
        {tiers.map((tier) => {
          const plan = availablePlans[tier]
          const name = translate(`names.${tier}`)

          return (
            <TierCard
              key={tier}
              tier={tier}
              name={name}
              price={formatPrice(plan.monthlyPrice)}
              priceTerm={translate('price_line', { annualPrice: formatPrice(plan.annualPrice) })}
              features={FEATURE_SLOTS.map((slot) => I18n.t(`${FEATURES_KEY_PREFIX}.${tier}.${slot}`, {
                ns: 'rails',
                lng: locale,
                modelCount: catalogValues?.[tier],
                downloads: plan.downloadsPerMonth,
                generations: plan.generationsPerMonth,
              }))}
            >
              <Button
                type={tier === TIER.PREMIUM ? 'primary' : 'secondary'}
                href={`${paymentFormUrl}?tier=${tier}&plan=${PLAN_MONTHLY}`}
                customClass="tier-card__cta"
              >
                {translate('cta', { plan: name })}
              </Button>
            </TierCard>
          )
        })}
      </div>
    </section>
  )
}

NoSubscription.propTypes = {
  availablePlans: availablePlansShape.isRequired,
  catalogValues: catalogValuesShape,
  paymentFormUrl: string.isRequired,
  showPremiumPlans: bool,
  locale: string,
}

export default NoSubscription
